// Auto-generated build version — updated by post-build.cjs
export const BUILD_VERSION = "11.09.2026, 12:22:27";
export const BUILD_TIMESTAMP = "2026-09-11T09:22:27.401Z";
